import React from "react";
import { LetterOfAuthorization, Header, Image, Subheader, InstructionListCheck, ContributionSubList, Guildelines, CharityACDetails, Print, OfficeAddress, LetterWrapper, FontBoldText } from "./styles";
import logo from '../../../../../../../../assets/icons/vcep-logo.png';
import printIcon from "../../../../../../../../assets/icons/print.svg";
import PrintComponents from "react-print-components";
import { StyleLessButton } from "../../../../../../../../CommonComponents/commonStyles";
import { IconPadding,DataExportPrint } from "../../../../styles";
import { removeHeaderFooter } from "../../../../utils";
let check = [];

export class ViewContribution extends React.Component {

    componentDidMount = () => {
        removeHeaderFooter();  
    }

    renderPrintData = () => {
        return (<LetterOfAuthorization>
            <Image justifyContent = "flex-start" marginBottom="10px">
                <img src={logo} alt="vanguard"></img>
            </Image>
            <Header>Remittance slip</Header>
            <Subheader>Contribution by check or Electronic Bank Transfer</Subheader>
            <InstructionListCheck>
                <li>
                    <span>Contribution by check</span>
                    <div>To complete your contribution by check to Vanguard Charitable, verify your information below. Print this
                        completed remittance slip and mail it with your signed check (made out to Vanguard Charitable
                        Endowment Program) in one envelope to:</div>
                    <OfficeAddress className="mt-10">
                        <div>
                            <div>By U.S. mail:</div>
                            <div>Vanguard Charitable</div> 
                            <div>P.O. Box 9509</div>
                            <div>Warwick, RI 02889-9509</div>
                        </div>
                        <div>
                            <div>By registered, certified, or overnight mail:</div>
                            <div>Vanguard Charitable</div> 
                            <div>2670 Warwick Avenue</div>
                            <div>Warwick, RI 02889-9509</div>
                        </div>
                    </OfficeAddress>
                </li>
                <li>
                    <span>Contribution by Electronic Bank Transfer</span>
                    <div>To complete your contribution by EBT to Vanguard Charitable, you must both inform Vanguard Charitable
                        of your intended donation and instruct your bank to send Vanguard Charitable the donation. If contributing
                        by EBT, you do not need to send this remittance slip to Vanguard Charitable.
                    </div>
                    <div className='mt-10'>
                        Note: Each bank has a different process and timeframe for processing an EBT contribution. We recommend
                        you confirm with your bank that the transaction has been completed. 
                    </div>
                    <ContributionSubList>
                        <li>Log in
                            <span> to your bank's website.
                            </span>
                        </li>
                        <li>Initiate
                            <span> an Electronic Bank Transfer, which is often achieved using the "Bill Pay" functionality on a
                                bank's secure website. (EBTs are processed through the Automated Clearing House network.) If this
                                option is not available, please contact your bank for assistance.
                            </span>
                        </li>
                        <li>
                            Search
                            <span> the "Biller," "Merchant," or "Remit To" organization for "Vanguard Charitable Endowment
                                Program". If you cannot find the name on your list of approved recipients, enter the following
                                information:
                            </span>
                            <CharityACDetails marginLeft="100px">
                                <div>Vanguard Charitable</div> 
                                <div>P.O. Box 9509</div>
                                <div>Warwick, RI 02889-9509</div>
                                <div>Phone: 888-383-4483</div>   
                            </CharityACDetails>   
                        </li>
                        <li>
                            Specify
                            <span> the amount of your donation and, if available, the effective date you would like the
                                contribution to be processed.
                            </span>
                        </li>
                        <li>
                            Add
                            <span> your Vanguard Charitable account number and name to the "memo," "notes," or "additional
                                information" field of your EBT transfer request.
                            </span>
                        </li>
                    </ContributionSubList>
                </li>
            </InstructionListCheck>       
            <CharityACDetails marginLeft="0px">
            <div>Your name: {check.name}</div>
                {check.type !== "Individual" ? <div>Donor name: { check.type !== "Joint" ? check.donorName : (check.firstName + ' ' +  check.lastName)}</div> : "" }
                <div>Vanguard Charitable account number: { check.logAcNum }</div>
                <div>Vanguard Charitable account name: { check.logAcName }</div>
                <div>Source of donation: {check.type === 'Joint' ? 'Joint Donor' : check.type}</div>
                <div>Contribution amount: {check.amount}</div>
            </CharityACDetails>
            <Guildelines>
                If applicable, Vanguard Charitable will send a tax substantiation letter once the contribution is processed.
                For more information, view our <a href={check.envURL + "/company-policies/policies-and-guidelines"} target="_blank">
                <span>Policies & Guidelines</span></a> booklet.
            </Guildelines>
        </LetterOfAuthorization>  
        
        );
    }

    render() {
        check = [];
        check = localStorage["check"] ? JSON.parse(localStorage["check"]) : [];
        return (
                     <LetterWrapper> 
                     <PrintComponents
                        className="i_print"
                        trigger={
                          <Print>
                          <StyleLessButton>
                            <IconPadding className="ml2">
                              <img src={printIcon} alt="print" />
                              <DataExportPrint>PRINT</DataExportPrint>
                            </IconPadding>
                          </StyleLessButton>
                          </Print>
                        } >
                            {this.renderPrintData()}
                        </PrintComponents>
                     {this.renderPrintData()}</LetterWrapper>
            );
                
    }
}

export default ViewContribution;


